import './App.css';

// importacao de componentes
import Formulario from "./components/Formulario";

function App() {
  return (
    <div className="App">
      <Formulario titulo={"Formulário de Cadastro React"} />
    </div>
  );
}

export default App;
